<!-- 签单订单批量添加 -->
<template>
	<div>
		<el-form ref="form" label-width="120px" size="medium">
			<el-form-item required label="平台">
				<el-col :span="12">
					<el-select v-model="create_data.platform" clearable placeholder="请选择">
						<el-option v-for="item in platform_list" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-col>
			</el-form-item>
			<el-form-item required label="国家">
				<el-col :span="12">
					<el-select v-model="create_data.country" clearable placeholder="请选择">
						<el-option v-for="item in country_list" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-col>
			</el-form-item>
			<el-form-item required label="发货类型">
				<el-col :span="12">
					<el-radio-group v-model="create_data.send_type">
						<el-radio :label="1">仓库发货</el-radio>
						<el-radio :label="2">商户发货</el-radio>
					</el-radio-group>
				</el-col>
			</el-form-item>
			<el-form-item label="分组">
				<el-col :span="12">
					<el-select v-model="create_data.group" clearable placeholder="请选择">
						<el-option v-for="item in group_list" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-col>
			</el-form-item>
			<el-form-item required label="面单上传">
				<el-col :span="12">
					<PdfUpload @imgList="pdfU" :img_num="100" :img_edit="create_data.doc_url"></PdfUpload>
				</el-col>
			</el-form-item>
			<el-form-item label="物流备注">
				<el-col :span="4">
					<el-input placeholder="选填" v-model="create_data.wl_remarks" clearable> </el-input>
					</el-input>
				</el-col>
			</el-form-item>
		</el-form>

		<el-divider content-position="left">添加预览（上传完成后，请不要删除或者重新上传，否则会重置数据）</el-divider>

		<el-button type="warning" @click="docDo">识别面单</el-button>
		<span> 共 {{doc_data_count}} 单</span>
		<el-button type="danger" style="margin-left: 100px;" @click="delSuccess">删除已成功订单</el-button>

		<el-table :data="create_data.data" style="width: 100%">
			<el-table-column prop="name" label="文件名"></el-table-column>
			<el-table-column prop="shop_name" label="店铺名">
				<template slot-scope="{row,$index}">
					<el-input v-model="row.shop_name"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="order_number" label="订单号">
				<template slot-scope="{row,$index}">
					<el-input v-model="row.order_number"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="tn_number" label="运单号">
				<template slot-scope="{row,$index}">
					<el-input v-model="row.tn_number"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="price" label="金额">
				<template slot-scope="{row,$index}">
					<el-input-number v-model="row.price" :precision="2" :step="0.1"></el-input-number>
				</template>
			</el-table-column>
			<el-table-column prop="address" label="收货地址">
				<template slot-scope="{row,$index}">
					<el-input type="textarea" v-model="row.address"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="msg" label="信息">
				<template slot-scope="{row,$index}">
					<span v-if="row.msg == '成功'" style="color: green;">{{row.msg}}</span>
					<span v-if="row.msg != '成功'" style="color: red;">{{row.msg}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="" label="操作">
				<template slot-scope="{row,$index}">
					<el-popconfirm @confirm="orderDel($index)" @onConfirm="orderDel($index)"
						title="确定删除？">
						<el-button style="margin-left:10px;" type="danger" size="mini" slot="reference">删除
						</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		
		<el-button v-if="create_data.data.length > 0" :loading="this.$store.state.ajaxLoading" style="margin-left: 45%;margin-top: 20px;" type="primary" @click="tj">提交</el-button>
	</div>
</template>

<script>
	import {
		orderAddBatch,
		docAnalysis,
	} from '@/api/sign_shop';
	import {
		alertMsg
	} from '@/tool/index';
	import Qs from 'qs'
	import PdfUpload from '@/components/Ele/pdfUpload.vue'; // 上传pdf组件
	export default {
		name: 'docBatchAdd',
		components: {
			PdfUpload,
		},
		data() {
			return {
				create_data: {},
				doc_data: {}
			}
		},
		computed: {
		    doc_data_count () {
		        return this.create_data.data.length;
		    }
		},
		props: { // 定义组件的属性
			platform_list: {
				type: Array,
				default: [],
			},
			country_list: {
				type: Array,
				default: [],
			},
			group_list: {
				type: Array,
				default: [],
			},
			is_show_create_batch:{
				type:Boolean,
				default:false,
			}
		},
		watch: {
			is_show_create_batch() {
				this.resetCreateData()
			},
		},
		created() {
			this.resetCreateData()
		},
		methods: {
			resetCreateData() { // 重置create_data数据
				this.create_data = {
					platform: '',
					country: '',
					send_type: 1,
					group: '',
					doc_url:[], // 这个参数没用，只不过为了兼容上传
					data: [],
				}
			},
			// pdf上传后的回调
			pdfU(e, a) {
				// 如果是添加文件
				if (a == 'add') {
					let temp = {
						name: e.name,
						doc_url: e.url,
						order_number:'',
						shop_name:'',
						tn_number:'',
						price: 0,
						msg:'',
						address:''
					}
					this.create_data.data.push(temp);
					this.create_data.data.forEach((item,index)=>{
						this.create_data.data.forEach((item2,index2)=>{
							if(item.doc_url == item2.doc_url && index != index2){
								console.log(index+'-'+index2+'有重复'+item.doc_url)
							}
						});
					});
					console.log(this.create_data.data)
				}
				// 如果是删除文件
				if (a == 'del') {
					this.create_data.data.forEach((item, index) => {
						if (item.doc_url == e.url) {
							this.create_data.data.splice(index, 1);
							return false;
						}
					});
				}
			},
			// 识别面单
			async docDo() {
				// 这个不要删，用来检测是否是有重复
				console.log(this.create_data.data);
				// // 检测是否有重复的文件
				// this.create_data.data.forEach((item,index)=>{
				// 	this.create_data.data.forEach((item2,index2)=>{
				// 		if(item.doc_url == item2.doc_url && index != index2){
				// 			console.log('有重复')
				// 		}
				// 	});
				// });
				
				// console.log('没有重复')
				// return false;
				
				if (this.create_data.data.length == 0) {
					return alertMsg(this, '请先上传面单');
				}
				if (!this.create_data.platform) {
					return alertMsg(this, '请先选择平台');
				}
				if (!this.create_data.country) {
					return alertMsg(this, '请先选择国家');
				}
				
				alertMsg(this, '识别中,请等待...','success');
				// const loading = this.$loading({
				// 	lock: true,
				// 	text: '识别中，请稍等',
				// 	spinner: 'el-icon-loading',
				// 	background: 'rgba(0, 0, 0, 0.7)'
				// });

				for (let i = 0; i < this.create_data.data.length; i++) {
					let temp = {
						platform: this.create_data.platform,
						country: this.create_data.country,
						doc_url: this.create_data.data[i].doc_url,
					};
					await this.docDo2(temp);
					this.create_data.data[i].address = this.doc_data.address;
					this.create_data.data[i].order_number = this.doc_data.order_number;
					this.create_data.data[i].price = this.doc_data.price;
					this.create_data.data[i].shop_name = this.doc_data.shop_name;
					this.create_data.data[i].tn_number = this.doc_data.tn_number;
				}
				
				alertMsg(this, '识别完成','success');
				// loading.close();
			},
			// 解析面单
			async docDo2(data) {
				let post = {
					platform: data.platform,
					country: data.country,
					url: data.doc_url
				}
				this.doc_data = {};
				await docAnalysis(Qs.stringify(post)).then(response => {
					this.doc_data = response.result;
				})
			},
			// 删除列表数据
			orderDel(index){
				this.create_data.data.splice(index, 1);
			},
			// 删除已成功订单
			delSuccess(){
				let new_data = [];
				this.create_data.data.forEach((item,index)=>{
					if(item.msg != '成功'){
						new_data.push(item);
					}
				});
				this.create_data.data = new_data;
			},
			// 提交订单
			tj(){
				this.$store.commit('setAjaxLoading', true);
				let post = {
					data:JSON.stringify(this.create_data)
				}
				orderAddBatch(Qs.stringify(post)).then(response => {
					let r = response.result;
					this.create_data.data.forEach((item,index)=>{
						r.forEach((item2,index2)=>{
							if(item.doc_url == item2.doc_url){
								this.create_data.data[index].msg = item2.msg;
							}
						});
					});
					
					alertMsg(this, '共处理'+r.length+'条订单','success');
				})
			},
		}
	}
</script>

<style>
	.el-col-12 {
		text-align: left;
	}
</style>
